/**
 * Checks if the user received is the OWNER of the Course
 * @param {*} course
 * @param {*} user
 */
export const isUserCourseOnwer = (course, user) =>
  !!course?.teacher.id && !!user?.id && course?.teacher.id === user?.id;
